// Filename: gani_publish.js
// Timestamp: 2018.12.09-01:17:42 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import { render } from 'inferno'
import { hydrate } from 'inferno-hydrate'

import {
  gnenumNSSUBJ as NSSUBJ,
  gnenumLOGREPORTS as LOGREPORTS
} from './gnenum.js'

import {
  gnreport_iskeyreplaced,
  gnreport_addreplacekey,
  gnreportNodeSubjChangedGet as reportNodeSubjChangedGet,
  gnreportRender as reportRender
} from './gnreport.js'

import patch from './gnpatch.js'

import {
  gnrenderHydrateVNode as renderHydrateVNode
} from './gnrender.js'

import {
  gnnodeosChildRmAll,
  gnnodeosxAttachDFS,
  gnnodeosxOnSubj
} from './gnnodeos.js'

const gnpublish_getrootvtree = (cfg, dom = cfg.dom, doc) => (
  doc = dom && dom.window.document || document,
  cfg.isrootbody ? doc.body : doc.body.firstElementChild)

const gnpublish_persistgraph = (cfg, graph) => (
  cfg.graph = graph)

const gnpublish_vtree = (ss, cfg, gr, vtree, dom) => {
  const rootvdom = gnpublish_getrootvtree(cfg, cfg.dom || dom)

  // inferno unable to use 'HTML' dom root to apply 'BODY' vnode
  if (rootvdom.tagName === 'BODY' && vtree.type === 'body')
    vtree = cfg.hfrag(vtree.children)

  // inferno.hydrated must be applied to pre-existing nodetree
  // that was server-rendered. Assume server rendered content
  // if root node has any children (incl. whitespace or comments)
  if (!cfg.ishydrated && rootvdom.hasChildNodes()) {
    cfg.ishydrated = true

    hydrate(vtree, rootvdom)
  }

  render(vtree, rootvdom)
  gnpublish_persistgraph(cfg, gr)
}

const gnpublish_renderroot = async (ss, cfg, gr) => (
  renderHydrateVNode(ss, cfg, gr, false))

const gnpublish_domgraph = async (ss, cfg, gr) => {
  let vtree, report
  const res = await gnpublish_renderroot(ss, cfg, gr)

  gr = res[0]
  // nd = res[1],
  vtree = res[2],
  report = res[3]

  gnpublish_vtree(ss, cfg, gr, vtree)

  return [gr, report, vtree]
}

// keyvalarr === [ [ nodekey, valobj ] ]
const gnpublish_patchgraph = async (ss, cfg, gr, keynsarr) => {
  const res = await patch(ss, cfg, gr, keynsarr)
  const grpatched = res[0]
  const report = res[1]

  return [grpatched, report]
}

//
// 1. update subj
// 2. patch dependent values in graph
//
// does not update document
// does not persist graph
//
// returns graph changes that will not appear in the rest of the app
// keyvalarr === [ [ nodekey, valobj ] ]
// const gnpublish_graphsubjsilent = async (ss, cfg, gr, ndkey, subj) => {
//   let res, rep
//
//   res = await gnpublish_patchgraph(ss, cfg, gr, [[ndkey, subj]])
//   gr = res[0]
//   rep = res[1]
//
//   return [gr, rep]
// }

const gnpublish_domgraphupdate = async (ss, cfg, gr, ndkey, report) => {
  if (report.replacearr.length) {
    if (cfg.logger.levels[LOGREPORTS])
      cfg.logger.log(`domreplace: ${ndkey}`)

    let res = await gnpublish_domgraph(ss, cfg, gr)
    gr = res[0]
    report = res[1]
  }

  return [gr, report]
}

//
// 1. update subj
// 2. patch dependent values in graph
// 3. if necessary, *apply graph to dom*
// 4. persist graph
//
// keyvalarr === [ [ nodekey, valobj ] ]
const gnpublish_graphsubj = async (ss, cfg, gr, pxuarr, ispersist) => {
  let res, rep
  if (!pxuarr.length)
    return [gr]

  res = await gnpublish_patchgraph(ss, cfg, gr, pxuarr)
  gr = res[0]
  rep = res[1]

  await Promise.all(reportNodeSubjChangedGet(rep).map(async patchkey => {
    // note, nodexonsubj mutates dom
    if (!await gnnodeosxOnSubj(ss, cfg, gr, gr.get(patchkey))
      && !gnreport_iskeyreplaced(rep, patchkey)
    ) {
      rep = gnreport_addreplacekey(rep, patchkey)
    }
  }))

  // publish against first key
  res = await gnpublish_domgraphupdate(ss, cfg, gr, pxuarr[0][0], rep)
  gr = res[0]
  // log against first key
  if (cfg.logger.levels[LOGREPORTS])
    cfg.logger.log(reportRender(rep))

  rep.replacearr.map(key => gnnodeosxAttachDFS(ss, cfg, gr, gr.get(key)))
  rep.patchkeyarr.map(key => gnnodeosxOnSubj(ss, cfg, gr, gr.get(key)))

  if (ispersist !== false)
    gr = gnpublish_persistgraph(cfg, gr)

  return [gr, rep]
}

const gnpublish_subj = async (ss, cfg, ndkey, subj) => {
  let gr = cfg.graph, rep, res

  res = await gnpublish_graphsubj(
    ss, cfg, gr, [[ndkey, NSSUBJ, subj]])
  gr = res[0]
  rep = res[1]
  // gr = gnpublish_persistgraph(cfg, gr)

  return [gr, rep]
}

const gnpublish_rmchilds = (ss, cfg, ndkey) => (
  gnnodeosChildRmAll(ss, cfg, cfg.graph, cfg.graph.get(ndkey)))

export {
  gnpublish_subj as default,
  gnpublish_subj as gnpublish,
  gnpublish_getrootvtree,
  gnpublish_persistgraph,
  gnpublish_vtree,
  gnpublish_renderroot,
  gnpublish_domgraph,
  gnpublish_patchgraph,
  gnpublish_domgraphupdate,
  gnpublish_graphsubj,
  gnpublish_subj,
  gnpublish_rmchilds
}
